import { render } from "./AuthPrefRetention.vue?vue&type=template&id=734f8676&ts=true"
import script from "./AuthPrefRetention.vue?vue&type=script&lang=ts"
export * from "./AuthPrefRetention.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__